import { Spacer } from "components/views/atoms/Atoms"
import { BodySmall } from "components/views/atoms/Bodies"
import { CircleImage } from "components/views/atoms/images/CircleImage"
import L10n from "lib/carrot-l10n"
import React from "react"
import styled from "styled-components"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const LegalFooter = styled.div`
  display: flex;
  margin-top: 40px;
  margin-bottom: 48px;
  padding-top: 12px;
  border-top: 1px solid #ebebeb;
  @media screen and (max-width: 750px) {
    flex-wrap: wrap;
  }
`

const ImageContainer = styled.div`
  display: flex;
  margin: 0 16px 12px 0;
`

const TalkToCarrotLegal = () => (
  <LegalFooter>
    <ImageContainer>
      <CircleImage iconName="icn-help" backgroundColor="light-gray" />
    </ImageContainer>
    <div>
      <BodySmall color="black-60">{l`client.experts.details1`}</BodySmall>
      <Spacer height={1} />
      <BodySmall color="black-60">{l`client.experts.details2`}</BodySmall>
    </div>
  </LegalFooter>
)

export { TalkToCarrotLegal }
